module.exports = __webpack_public_path__ + "img/Feature.db6aa181.png";